import React        from 'react';
import PropTypes    from 'prop-types';
import Translations from '../../../utils/Translations';

const AgeRestrictionLabel = (props) => (
	props.ageRating === 18
		? <div className="dailybonus-badge --ab">{Translations.get('Over18')}</div>
		: null
);

AgeRestrictionLabel.propTypes = {
	ageRating: PropTypes.number,
};

export default AgeRestrictionLabel;
